var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from "react";
import FormContainer from "../formContainer/formContainer";
import { useResourcesList } from "../../../hooks/useResourcesList";
import Button from "../../../../../server/public/shared/ui/inputs/classicButton";
export default function ResourceSelector(props) {
    const [resourcesList, getResource] = useResourcesList();
    const [menuOpened, setMenuOpened] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    return (React.createElement("div", null,
        React.createElement(Button, { text: "Wybierz zas\u00F3b", onClick: () => setMenuOpened(true) }),
        props.state && (React.createElement(React.Fragment, null,
            React.createElement("br", null),
            "Wybrano zas\u00F3b:",
            " ",
            typeof props.state === "string" ? props.state : props.state.name)),
        menuOpened && (React.createElement(FormContainer, { notify: () => { }, inputs: [
                {
                    type: "select",
                    name: "watermark",
                    label: "Wybierz zasób",
                    params: {
                        options: resourcesList.map((resource) => ({
                            label: resource.name,
                            value: resource.name,
                        })),
                    },
                },
            ], isLoading: isLoading, onSubmit: (results) => __awaiter(this, void 0, void 0, function* () {
                setIsLoading(true);
                const resource = yield getResource(results.watermark.value);
                setIsLoading(false);
                props.onSelect(resource);
                setMenuOpened(false);
            }), onReject: () => setMenuOpened(false) }))));
}
